import { AxiosError } from 'axios'
import { flow, makeObservable } from 'mobx'

import { openPdfDocumentFromBlob } from 'Shared/utils'

import { STORE_UI } from 'Core/constants'
import { searchQueryConfig } from 'Core/constants/filters'
import { CoreUrlParams, CustomGenerator, SortingParams } from 'Core/interfaces'
import { TableStore } from 'Core/stores/tableStore/TableStore'
import { storagePageSizeConstant } from 'Core/utils/storeHelpers/storagePageSizeConstant'

import { BackupDocument } from 'Portals/Customer/entities'
import { BackupDocumentRepo } from 'Portals/Customer/repositories'
import { RootStore } from 'Portals/Customer/stores'

import { UrlParams } from '../../constants'
import {
	getFiltersConfig,
	getSearchConfig
} from '../../Pages/BackupDocument/TableList/Filters/config'

const STORAGE_BACKUP_DOCUMENT_PAGE_SIZE = storagePageSizeConstant('backupDocument')

export class BackupDocumentTable extends TableStore<BackupDocument.Basic> {
	constructor(private rootStore: RootStore) {
		super(STORAGE_BACKUP_DOCUMENT_PAGE_SIZE)
		makeObservable(this)
	}

	@flow.bound
	*getItems(defaultSort?: SortingParams) {
		try {
			yield this.requestData({
				repository: BackupDocumentRepo.getList,
				defaultSort
			})
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification(error as AxiosError)
		}
	}

	@flow.bound
	*downloadDocument(fileName: string): CustomGenerator<Blob> {
		try {
			const document = yield BackupDocumentRepo.downloadDocument(fileName)

			openPdfDocumentFromBlob(document, fileName)
		} catch (error) {
			this.rootStore[STORE_UI].showErrorNotification()
		}
	}

	initFromURLParams = (params: Record<string, string[]>) => {
		const searchKeys = [UrlParams.id, CoreUrlParams.searchQuery]

		const filterKeys = [
			UrlParams.startDate,
			UrlParams.endDate,
			UrlParams.statusId,
			UrlParams.serviceSiteId
		]

		const mergedSearchConfig = {
			...getSearchConfig(),
			...searchQueryConfig
		}

		this.initSearchParamsFromUrl(params, searchKeys, mergedSearchConfig)
		this.initFilterParamsFromUrl(params, filterKeys, getFiltersConfig())
	}
}
